import { render } from "./g-ozg-payment-page.vue?vue&type=template&id=80c601e0&ts=true"
import script from "./g-ozg-payment-page.vue?vue&type=script&lang=tsx"
export * from "./g-ozg-payment-page.vue?vue&type=script&lang=tsx"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__